import React from "react";

// components
import SelectInput from "../../../../../../components/Inputs/SelectInput";
import Text from "../../../../../../components/Text";

// schema
import { ScatterAxis } from "../../../../schema";
// css
import css from "./FactorComparison.module.scss";

interface IControlsProps {
	xAxis: ScatterAxis;
	setXAxis: (axis: ScatterAxis) => void;
	yAxis: ScatterAxis;
	setYAxis: (axis: ScatterAxis) => void;
	allOptions: string[];
}
/**
 * Dropdowns to use within the "toolbar" section of the card
 */
const ComparisonDropdowns = (props: IControlsProps) => {
	const { xAxis, setXAxis, yAxis, setYAxis, allOptions } = props;

	const xAxisFactorOptions = allOptions
		.filter((fact) => fact !== yAxis)
		.map((factor) => ({
			label: factor === "all" ? "Overall Satisfaction" : factor,
			value: factor,
		}))
		.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));
	const yAxisFactorOptions = allOptions
		.filter((fact) => fact !== xAxis)
		.map((factor) => ({
			label: factor === "all" ? "Overall Satisfaction" : factor,
			value: factor,
		}))
		.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));
	return (
		<div className={css.dropdowns}>
			<div className={css.labeledInput}>
				<label htmlFor="x-axis">
					<Text size="caption" weight="semi-bold">
						X Axis
					</Text>
				</label>
				<div className={css.select}>
					<SelectInput
						size="small"
						isSearchable={false}
						inputId="x-axis"
						name="X-Axis"
						results={xAxisFactorOptions}
						value={xAxis}
						onChange={({ value }) => {
							setXAxis(value as ScatterAxis);
						}}
					/>
				</div>
			</div>
			<div className={css.labeledInput}>
				<label htmlFor="y-axis">
					<Text size="caption" weight="semi-bold">
						Y Axis
					</Text>
				</label>
				<div className={css.select}>
					<SelectInput
						size="small"
						isSearchable={false}
						inputId="y-axis"
						name="Y-Axis"
						results={yAxisFactorOptions}
						value={yAxis}
						onChange={({ value }) => {
							setYAxis(value as ScatterAxis);
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default ComparisonDropdowns;
